import { render, staticRenderFns } from "./othermsg.html?vue&type=template&id=158a858a&scoped=true&"
import script from "./othermsg.js?vue&type=script&lang=js&"
export * from "./othermsg.js?vue&type=script&lang=js&"
import style0 from "./othermsg.sass?vue&type=style&index=0&id=158a858a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158a858a",
  null
  
)

component.options.__file = "othermsg.vue"
export default component.exports